import cn from 'classnames'
import { isValidElement, memo } from 'react'

import { IItemDecorator } from '../../models'

import { IInnerListProps } from './models'

import styles from './InnerList.module.scss'

export const InnerList = memo<IInnerListProps>(({ children, className, hasShadow, innerRef }) => {
  if (Array.isArray(children) && !children.every(isValidElement<IItemDecorator>)) {
    throw 'List component has incorrect children'
  }

  if (!Array.isArray(children) && !isValidElement<IItemDecorator>(children)) {
    throw 'List component has incorrect children'
  }
  return (
    <nav
      ref={innerRef}
      className={cn(styles.menuItemList, className, { [styles.hasShadow]: hasShadow })}
    >
      {children}
    </nav>
  )
})
